/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRolePresetDto } from '../../models/backend-role-preset-dto';
import { BackendRolePresetCreateRequestDto } from '../../models/backend-role-preset-create-request-dto';

export interface AccessRolePresetsCreate$XWwwFormUrlencoded$Params {
  body: BackendRolePresetCreateRequestDto;
}

export function accessRolePresetsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: AccessRolePresetsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRolePresetDto>> {
  const rb = new RequestBuilder(rootUrl, accessRolePresetsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRolePresetDto>;
    }),
  );
}

accessRolePresetsCreate$XWwwFormUrlencoded.PATH = '/api/access/role-presets/';
